export const FILTER_RESOURCES = {
  Strain: 'strain',
  Weight: 'weight',
  Category: 'category',
  'Product tag': 'product tag',
  'Inventory tag': 'inventory tag',
  'Pricing tier': 'pricing tier',
  Brand: 'brand',
  Vendor: 'vendor',
  Product: 'product',
} as const;
